module.exports = __webpack_public_path__ + "static/media/5.19.6632a28c.png";